import {
  RESET_PASSWORD_FORM_LOADED,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  SET_PASSWORD_FORM_LOADED,
  SET_PASSWORD_REQUEST,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILURE,
} from '../../constants/actionTypes';
import { CALL_AUTH_API } from '../../middleware/api';
import { POST } from '../../constants/requestMethods';

export const resetPassword = (email, gRecaptchaResponse) => (dispatch) => {
  dispatch({
    [CALL_AUTH_API]: {
      types: [RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE],
      endpoint: '/reset_password',
      requestMethod: POST,
      payload: {
        email,
        g_captcha_response: gRecaptchaResponse,
      },
      ignoreErrors: true,
    },
  });
};

export const setPassword = (code, password) => (dispatch) => {
  dispatch({
    [CALL_AUTH_API]: {
      types: [SET_PASSWORD_REQUEST, SET_PASSWORD_SUCCESS, SET_PASSWORD_FAILURE],
      endpoint: '/set_password',
      requestMethod: POST,
      payload: {
        reset_token: code,
        password,
        password_confirmation: password,
      },
      ignoreErrors: true,
    },
  });
};

export const resetPasswordFormLoaded = () => (dispatch) => {
  dispatch({ type: RESET_PASSWORD_FORM_LOADED });
};

export const setPasswordFormLoaded = () => (dispatch) => {
  dispatch({ type: SET_PASSWORD_FORM_LOADED });
};
